import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { ProjectResourceType } from '~/types';

export const projectTeamMembersBySlugQuery = gql`
  query projectTeamMembersBySlugQuery(
    $projectSlug: String!
    $page: Int!
    $pageSize: Int!
    $resourceType: ProjectResourceType!
    $teamMemberFilter: ProjectTeamMemberDetailsFilter
  ) {
    project(projectSlug: $projectSlug) {
      id
      pageOfProjectTeamMemberDetails(
        page: $page
        pageSize: $pageSize
        resourceType: $resourceType
        filter: $teamMemberFilter
      ) {
        id
        displayText
        slug
        isAllocated
      }
    }
  }
`;

const DEFAULT_PAGE_SIZE = 100;

export const usePageOfProjectTeamMembers = ({
  projectSlug,
  searchTerm = '',
  pageSize,
  skip = false
}) => {
  const effectivePageSize = pageSize || DEFAULT_PAGE_SIZE;
  const { loading, error, data } = useQuery(projectTeamMembersBySlugQuery, {
    fetchPolicy: 'network-only',
    variables: {
      projectSlug,
      page: 1,
      pageSize: effectivePageSize,
      resourceType: ProjectResourceType.User,
      teamMemberFilter: searchTerm ? { searchText: searchTerm } : undefined
    },
    context: {
      debounceKey: `project-team-member-details-dropdown-${projectSlug}`,
      debounceTimeout: 250
    },
    skip
  });

  const teamMembers = data?.project?.pageOfProjectTeamMemberDetails;

  const users = useMemo(
    () =>
      (teamMembers || [])
        .map(user =>
          user.isAllocated ? user : { ...user, isUnusedTeamMember: true }
        )
        .sort((a, b) => Number(b.isAllocated) - Number(a.isAllocated)),
    [teamMembers]
  );

  return {
    loading,
    users,
    error,
    hasMore: users.length >= effectivePageSize
  };
};

export default usePageOfProjectTeamMembers;
